export class AuthError {
  constructor(private _original: any) {
  }

  get original(): any {
    return this._original;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/auth/auth-error.ts